import CustomLabelsController from './custom-labels-controller'

export default CustomLabelsController
